import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import Home from "./Home";
import User from "./User";
import GuestLayout from "layouts/GuestLayout";
import LayoutProvider from "./LayoutContext";
import ScanPage from "./ScanPage";
import UserLogin from "./UserLogin";
import CameraPermissionPage from "./CameraPermissionPage";
import ProtectedScanRoute from "./ProtectedScanRoute";
import ResultsPage from "./ResultPage";
import EdencareGetStarted from "./EdencareGetStarted";
import EdencareLogin from "./EdencareLogin";
import DiagnosticsPage from "./DiagnosticsPage";
import { getClientHomePath } from "utils/client";

// /login is only a fallback for visitors without a known client. When the client
// is known, send them to its own URL (/client/<slug>) so it stays in the address bar.
const LoginRoute = () => {
    let client = null;
    try {
        client = JSON.parse(localStorage.getItem("clientDetails") || "null");
    } catch {
        client = null;
    }
    if (client?.client_website_link) {
        return <Navigate to={getClientHomePath(client)} replace />;
    }
    return <UserLogin />;
};

export default function App() {
    return (
        <LayoutProvider>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route element={<GuestLayout />}>
                    <Route path="/client/:slug" element={<User />} />
                    <Route path="/login" element={<LoginRoute />} />
                    <Route path="/edencare" element={<EdencareGetStarted />} />
                    <Route path="/edencare/login" element={<EdencareLogin />} />
                </Route>
                <Route path="/camera-permission" element={<CameraPermissionPage />} />
                <Route
                    path="/scan"
                    element={
                        <ProtectedScanRoute>
                            <ScanPage />
                        </ProtectedScanRoute>
                    }
                />
                <Route path="/results" element={<ResultsPage />} />
                <Route path="/diagnostics" element={<DiagnosticsPage />} />
            </Routes>
        </LayoutProvider>
    );
}
